import React from "react";
import { connect } from "react-redux";
import {
  Transition,
  Container,
  Header,
  Segment,
  Button
} from "semantic-ui-react";
import AsignacionActividades from "./shared/colegios/AsignacionActividades";
import ColegioForm from "./shared/colegios/ColegioForm";
import { colegiosOps } from "../ducks/colegios";

class NuevoColegio extends React.Component {
  state = { visible: false };

  componentDidMount() {
    this.setState({ visible: true });
  }

  handleVolver = () => this.props.history.goBack();

  render() {
    const { detalleColegio } = this.props;

    return (
      <Transition.Group animation="scale" duration={250}>
        {this.state.visible && (
          <Container>
            <Segment basic>
              <Segment basic>
                <Button
                  content="Cerrar"
                  floated="right"
                  color="pink"
                  icon="cancel"
                  onClick={this.handleVolver}
                />
                <Header inverted as="h2" textAlign="center">
                  Nuevo Colegio
                </Header>
              </Segment>

              <ColegioForm action={this.props.saveDataColegio} />
              <AsignacionActividades
                idColegio={detalleColegio ? detalleColegio.id : null}
                nombreColegio={detalleColegio ? detalleColegio.nombre : null}
              />
            </Segment>
          </Container>
        )}
      </Transition.Group>
    );
  }
}

const mapStateToProps = state => ({
  detalleColegio: state.colegios.detalleColegio
});

const actions = {
  /*- colegiosOps -*/
  saveDataColegio: colegiosOps.saveDataColegio,
  updateDataColegio: colegiosOps.updateDataColegio,
  resetDetalleColegio: colegiosOps.resetDetalleColegio
};

export default connect(mapStateToProps, actions)(NuevoColegio);



// WEBPACK FOOTER //
// ./src/pages/NuevoColegio.jsx